import { render, staticRenderFns } from "./MyDocumentsMain.vue?vue&type=template&id=217de4ec&scoped=true&"
import script from "./MyDocumentsMain.vue?vue&type=script&lang=js&"
export * from "./MyDocumentsMain.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentsMain.vue?vue&type=style&index=0&id=217de4ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217de4ec",
  null
  
)

export default component.exports